// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yDTOKZH7Q24TLPjT_idI{white-space:nowrap;text-overflow:ellipsis;max-width:250px;display:flex;overflow:hidden}.NI8hYTCMsJI5NUsBtvso{max-width:244px}.CA2xcZUF6osG3dqDb8cI{justify-content:flex-end;gap:8px;margin-top:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelRightWrapper": `yDTOKZH7Q24TLPjT_idI`,
	"selectedInboxName": `NI8hYTCMsJI5NUsBtvso`,
	"actions": `CA2xcZUF6osG3dqDb8cI`
};
export default ___CSS_LOADER_EXPORT___;
